// Analytics - page visit and download tracking

const API_BASE = '/api';

/**
 * Track a page visit. Called on each route change from App.jsx.
 * Fire-and-forget — errors are silently caught.
 */
// Only count the external referrer once per session
let referrerSent = false;

export const trackVisit = async () => {
  try {
    // Only include referrer if it's from an external site and hasn't been sent yet
    let referrer = '';
    if (!referrerSent && document.referrer) {
      try {
        const referrerHost = new URL(document.referrer).hostname;
        if (referrerHost !== window.location.hostname) {
          referrer = document.referrer;
          referrerSent = true;
        }
      } catch {
        // Invalid referrer URL, ignore
      }
    }

    await fetch(`${API_BASE}/track-visit.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        page: window.location.pathname,
        referrer,
        userAgent: navigator.userAgent,
      }),
    });
  } catch {
    // Silent failure - tracking should never break the user experience
  }
};

/**
 * Track a download event. Called from Download.jsx when a download starts.
 */
export const trackDownload = async (additionalData = {}) => {
  try {
    const response = await fetch(`${API_BASE}/track-download.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        userAgent: navigator.userAgent,
        referrer: document.referrer,
        url: window.location.href,
        viewport: {
          width: window.innerWidth,
          height: window.innerHeight,
        },
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        ...additionalData,
      }),
    });

    if (!response.ok) {
      throw new Error(`Server responded with ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Failed to track download:', error);
    return null;
  }
};
